import { getProjectConfig } from "../../../../getProjectConfig";

export const currencyFormatter = (e:any) => {
  if (e.value === undefined || e.value === '' || e.value === null) {
    return 'N/A'
  }
  return `${getProjectConfig().CURRENCY_SYMBOL} ${Math.round(e.value).toLocaleString('en-US')}`;
};